<template>
  <div class="verify-layout">
    <!-- 顶部区域开始 -->
    <div class="navigation">
      <div class="nav_left"></div>
      <div class="nav_right">欢迎使用飞译人机合译平台！</div>
    </div>
    <!-- 顶部区域结束 -->
    <!--  主视图区域开始 -->
    <div class="content">
      <router-view />
    </div>
    <!-- 主视图域结束 -->
    <!-- 底部区域开始 -->
    <div class="footer">Copyright @ 2018-2021 anylangtech. All Rights Reserved. 中科凡语 版权所有</div>
    <!-- 底部区域结束 -->
  </div>
</template>

<script>
export default {
  name: "VerifyLayoutbackground",
  components: {},
  data() {
    return {
      // alignFlag: process.env.VUE_APP_HOSPITAL === "align"
    };
  },
  methods: {
    goRegister() {
      this.$router.push("/login/registration");
    },
    login_in() {
      this.$router.push("/login/newLogin");
    }

  }
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>